import { useEffect, useState } from "react";
import { useHistory } from 'react-router-dom';
import Error500 from "../error/500";
import { bookcover, home } from "../../api/api";
import { Col, Image, Row, Space } from "antd";
import ListCard from "../../component/dashboard/list_Card";
import bannerImage from '../../asset/images/banner-sldr.png';

const Dashboard = () => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const isOnline = navigator.onLine; // Check online status

  const getRandom = () => {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  };
  
  const getUniqueId = () => {
    return `${Date.now()}-${getRandom()}-${getRandom()}-${getRandom()}`;
  };

  let sessionId = localStorage.getItem('sessionId');
  if (sessionId==null) {
    sessionId = getUniqueId();
    localStorage.setItem('sessionId', sessionId);
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    if (isOnline) {
      fetchDashboardData();
    } else {
      loadOfflineData();
    }
  }, [isOnline]);

  const fetchDashboardData = async () => {
    setIsLoading(true);
    try {
      let response = await fetch(home);
      let data = await response.json();
      setData(data);
      setIsLoading(false);
      for (let book of data.recentBooks) {
        const res = await fetch(bookcover + book.fuzzyId + "/" + book.cover); // Fetch the image
        const blob = await res.blob(); // Convert response to Blob
        const reader = new FileReader();
  
        // Convert the Blob to Base64 and store it in coverUrl
        await new Promise((resolve, reject) => {
          reader.onloadend = () => {
            book['coverUrl'] = reader.result; // Set coverUrl
            resolve(); // Resolve when done
          };
          reader.onerror = reject; // Reject on error
          reader.readAsDataURL(blob); // Convert Blob to Base64
        });
      }
      saveDataToIndexedDB("dashboard", data);
      console.log("Book covers loaded successfully.");
    } catch (err) {
      setError(true);
      setIsLoading(false);
      console.error("Failed to load book covers:", err);
    }
  };

  const openDatabase = (storeName) => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open("MyDataBase");
  
      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains(storeName)) {
          db.createObjectStore(storeName, { keyPath: "id" });
        }
      };
  
      request.onsuccess = (event) => {
        const db = event.target.result;
  
        // If the store exists, return the database
        if (db.objectStoreNames.contains(storeName)) {
          console.log(`Object store "${storeName}" already exists.`);
          return resolve(db);
        }
  
        console.warn(`Object store "${storeName}" is missing. Upgrading database...`);
        db.close();
  
        // Increment the version to trigger onupgradeneeded
        const newVersion = db.version + 1;
        console.log('newVersion', newVersion);
        const upgradeRequest = indexedDB.open("MyDataBase", newVersion);
  
        upgradeRequest.onupgradeneeded = (event) => {
          const upgradeDb = event.target.result;
  
          // Create only the missing object store
          if (!upgradeDb.objectStoreNames.contains(storeName)) {
            console.log(`Creating missing object store: ${storeName}`);
            upgradeDb.createObjectStore(storeName, { keyPath: "id" });
          }
        };
  
        upgradeRequest.onsuccess = (event) => {
          console.log(`Database upgraded. Object store "${storeName}" added.`);
          resolve(event.target.result);
        };
  
        upgradeRequest.onerror = (event) => {
          reject(event.target.error);
        };
      };
  
      request.onerror = (event) => {
        reject(event.target.error);
      };
    });
  };         

  const saveDataToIndexedDB = async (storeName, data) => {
    try {
      const db = await openDatabase(storeName);
      const transaction = db.transaction(storeName, "readwrite");
      console.log('storeName', storeName);
      const store = transaction.objectStore(storeName);

      // Use a fixed key to ensure that the record is overwritten each time.
      const dashboardRecord = {
        id: storeName, // fixed key
        data: data,      // your dashboard data
        timestamp: new Date().toISOString(), // Optional: keep a timestamp for reference
      };

      const requestPut = store.put(dashboardRecord);  
      requestPut.onsuccess = () => {
        console.log("Dashboard data successfully saved (overwritten) in IndexedDB");
      };

      requestPut.onerror = (event) => {
        console.error("Error saving dashboard data to IndexedDB:", event.target.error);
      };

      transaction.oncomplete = () => {
        db.close();
      };

    } catch (error) {
      console.error("Error opening database or saving dashboard data:", error);
    }
  };  

  // Load cached data when offline
  const loadOfflineData = () => {
    setIsLoading(true);
    openDatabase("dashboard")
      .then((db) => {
        const transaction = db.transaction("dashboard", "readonly");
        const store = transaction.objectStore("dashboard");
        const getRequest = store.get("dashboard"); // "dashboard" is the fixed key
  
        getRequest.onsuccess = function (event) {
          const record = event.target.result;
          setData(record ? record.data : null);
          db.close();
        };
  
        getRequest.onerror = function (event) {
          console.error("Error loading dashboard data:", event.target.error);
          db.close();
        };
      })
      .catch((error) => {
        console.error("Error opening database:", error);
      });
    setIsLoading(false);
  };

  const goToDescription = (item) => {
    history.push({
      pathname: '/book/isbn/' + item.identifier,
      state: { contentid: item.contentId, title: item.fullName, fuzzyid: item.fuzzyId },
    });
  };

  if (error) {
    return <Error500 />;
  }

  if (isLoading) {
    return (
      <Row style={{ marginTop: '10px' }}>
        <Col xs={24} lg={{ span: 20, offset: 2 }}>
          <ListCard cardtitel=" " data={[{}, {}, {}, {}, {}]} isBook={true} access={"paid"} isLoading={true} />
        </Col>
      </Row>
    );
  }

  const getCoverImage = (book) => {
    if (isOnline) {
      return bookcover + book.fuzzyId + "/" + book.cover;
    } else {
      return book.coverUrl; 
    }
  };

  const renderRecentBooks = (recentBooks = []) => {
    if (!Array.isArray(recentBooks) || recentBooks.length === 0) {
      return null; // Return nothing if recentBooks is not an array or empty
    }
  
    return recentBooks.map((item) => (
      <Col
        key={item.fuzzyId}
        xs={12}
        md={6}
        style={{ float: 'left', marginTop: '10px', padding: '10px' }}
      >
        <Space hig="1px" color="#ECF0EF" />
        <Image
          onClick={() => goToDescription(item)}
          className="bookcover"
          preview={false}
          fallback="data:image/png;base64,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"
          src={getCoverImage(item)}
          alt={item.fullName}
        />
        <Space hig="1px" color="#ECF0EF" />
        <p
          onClick={() => goToDescription(item)}
          className="ctitel"
          style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
        >
          {item.fullName}
        </p>
      </Col>
    ));
  };


  return (
    <div>
      <Row>
        <Col xs={24}>
          <Image preview={false} src={bannerImage} alt="International Pain and Spine Intervention Society" />
        </Col>
      </Row>
      <Row>
      {renderRecentBooks(data?.recentBooks)}
      </Row>
      <Row style={{ padding: '10px', textAlign:'center', fontSize: '16px', marginBottom: '100px' }}>
        <Col xs="{24}">
          <p>"This Technical Manual and Atlas brings together two disparate but complementary themes: to provide a standardized, evidence-based framework for the performance of interventional spine procedures while also describing nuances of anatomy and image guidance that can confound the unwary or reward the thoughtful practitioner. This is experiential knowledge accrued over decades of observation and practice, often unrecorded in the literature, that is the legacy of IPSIS physicians."</p>
          <p><i>Timothy P. Maus, MD</i></p>
        </Col>
      </Row>
    </div>
  );
}

export default Dashboard;